'use es6';

import * as MatchStatus from 'customer-data-filters/filterQueryFormat/MatchStatus';
import FormattedMessage from 'I18n/components/FormattedMessage';
import MatchStatusType from '../propTypes/MatchStatusType';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import UIStatusTag from 'UIComponents/tag/UIStatusTag';
import { jsx as _jsx } from "react/jsx-runtime";
const _matchDataByStatus = {
  [MatchStatus.FAIL]: {
    name: 'removed',
    text: 'customerDataFilters.FilterEditorLogicGroupStatusTag.textFail'
  },
  [MatchStatus.PASS]: {
    name: 'success',
    text: 'customerDataFilters.FilterEditorLogicGroupStatusTag.textPass'
  },
  [MatchStatus.PENDING]: {
    name: 'paused',
    text: 'customerDataFilters.FilterEditorLogicGroupStatusTag.textPending'
  }
};
export default class FilterEditorLogicGroupStatusTag extends PureComponent {
  render() {
    const {
      filterFamily,
      getFilterFamilyObjectName,
      matchStatus
    } = this.props;
    const matchData = _matchDataByStatus[matchStatus];
    if (!matchData) {
      return null;
    }

    // note: this will not work for custom objects
    const objectName = getFilterFamilyObjectName(filterFamily);
    return /*#__PURE__*/_jsx(UIStatusTag, {
      className: "m-left-1 m-top-2",
      use: matchData.name,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: matchData.text,
        options: {
          objectName
        }
      })
    });
  }
}
FilterEditorLogicGroupStatusTag.defaultProps = {
  matchStatus: 'PENDING'
};
FilterEditorLogicGroupStatusTag.propTypes = {
  filterFamily: PropTypes.string.isRequired,
  getFilterFamilyObjectName: PropTypes.func.isRequired,
  matchStatus: MatchStatusType
};